import React from "react";
import { Button, Checkbox } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { moveItemInArray } from "../utils/columnOrderUtils";

const reorderButtonStyle = {
  height: 18,
  width: 22,
  minWidth: 22,
  padding: 0,
  lineHeight: 1,
};

const ColumnSelectorPopover = ({
  columnOptions,
  orderedKeys,
  selectedKeys,
  onOrderedKeysChange,
  onSelectedKeysChange,
  onSave,
  onCancel,
  allowReorder = true,
}) => {
  const handleMove = (index, direction) => {
    onOrderedKeysChange(moveItemInArray(orderedKeys, index, direction));
  };

  return (
    <div style={{ minWidth: 260 }}>
      <div
        className="column-selector-list flex flex-col gap-0.5 [&_.ant-checkbox-wrapper]:!mb-0 [&_.ant-checkbox-wrapper]:!min-h-[24px] [&_.ant-checkbox-wrapper]:!items-center [&_.ant-checkbox+span]:!ps-1.5"
      >
        {orderedKeys.map((key, index) => {
          const option = columnOptions.find((col) => col.key === key);
          if (!option) {
            return null;
          }
          const isSelected = selectedKeys.includes(key);
          const isAction = key === "action";

          return (
            <div
              key={key}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 6,
                minHeight: 24,
              }}
            >
              <Checkbox
                checked={isSelected}
                onChange={(event) => {
                  const checked = event.target.checked;
                  if (checked) {
                    onSelectedKeysChange([...selectedKeys, key]);
                    return;
                  }
                  onSelectedKeysChange(
                    selectedKeys.filter((selectedKey) => selectedKey !== key),
                  );
                }}
              >
                {option.label}
              </Checkbox>
              {allowReorder && isSelected && !isAction && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                    flexShrink: 0,
                  }}
                >
                  <Button
                    type="text"
                    size="small"
                    icon={<UpOutlined style={{ fontSize: 10 }} />}
                    disabled={index === 0}
                    onClick={() => handleMove(index, "up")}
                    aria-label={`Move ${option.label} up`}
                    style={reorderButtonStyle}
                  />
                  <Button
                    type="text"
                    size="small"
                    icon={<DownOutlined style={{ fontSize: 10 }} />}
                    disabled={
                      index === orderedKeys.length - 1 ||
                      orderedKeys[index + 1] === "action"
                    }
                    onClick={() => handleMove(index, "down")}
                    aria-label={`Move ${option.label} down`}
                    style={reorderButtonStyle}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="flex justify-end mt-2 gap-2">
        <Button size="small" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" size="small" onClick={onSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default ColumnSelectorPopover;
